import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// User/Auth store
export const useUserStore = create(
  persist(
    (set, get) => ({
      userId: null,
      userName: null,
      userType: null,
      token: null,
      isAuthenticated: false,
      
      setUser: (userId, userName, userType, token) => set({
        userId,
        userName,
        userType,
        token,
        isAuthenticated: true,
      }),
      
      clearUser: () => set({
        userId: null,
        userName: null,
        userType: null,
        token: null,
        isAuthenticated: false,
      }),
      
      // Maintain compatibility with existing localStorage keys
      syncFromLocalStorage: () => {
        try {
          const userId = localStorage.getItem('ajs_user_id');
          const token = localStorage.getItem('_Host_Pro_Hckare_TKN');
          const userType = localStorage.getItem('_Host_Pro_type');
          
          if (userId && token) {
            const decodedUserId = window.atob(userId);
            const decodedUserType = userType ? window.atob(userType) : null;
            const [id, name] = decodedUserId.split(':');
            
            set({
              userId: id,
              userName: name,
              userType: decodedUserType,
              token: window.atob(token),
              isAuthenticated: true,
            });
          }
        } catch (error) {
          console.error('Error syncing from localStorage:', error);
        }
      },
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({
        userId: state.userId,
        userName: state.userName,
        userType: state.userType,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

// Group store (migrated from groupNumberReducer)
export const useGroupStore = create((set) => ({
  groupData: [],
  groupTemp: [],
  
  setGroupData: (data) => set({ groupData: [data] }),
  setGroupTemp: (data) => set({ groupTemp: [data] }),
  clearGroupData: () => set({ groupData: [], groupTemp: [] }),
}));

// Referral store
export const useReferralStore = create(
  persist(
    (set) => ({
      referralUrl: null,
      affiliateReferralUrl: null,
      
      setReferralUrl: (url) => {
        set({ referralUrl: url });
        localStorage.setItem('ReferralURL', url);
      },
      
      setAffiliateReferralUrl: (url) => {
        set({ affiliateReferralUrl: url });
        localStorage.setItem('AffiliateReferralURL', url);
      },
      
      clearReferralUrls: () => {
        set({ referralUrl: null, affiliateReferralUrl: null });
        localStorage.removeItem('ReferralURL');
        localStorage.removeItem('AffiliateReferralURL');
      },
    }),
    {
      name: 'referral-storage',
    }
  )
);

// UI store for modals, sidebar, etc.
export const useUIStore = create((set) => ({
  sidebarOpen: false,
  mobileMenuOpen: false,
  actionMenuOpen: false,
  
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),
  setActionMenuOpen: (open) => set({ actionMenuOpen: open }),
  
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  toggleMobileMenu: () => set((state) => ({ mobileMenuOpen: !state.mobileMenuOpen })),
  toggleActionMenu: () => set((state) => ({ actionMenuOpen: !state.actionMenuOpen })),
  
  closeAll: () => set({
    sidebarOpen: false,
    mobileMenuOpen: false,
    actionMenuOpen: false,
  }),
}));
